import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";
import { SiteProvider } from "@/lib/site";
import Home from "@/pages/Home";
import { Login, Register, Forgot, Reset, VerifyEmail } from "@/pages/AuthPages";
import Member from "@/pages/Member";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Legal from "@/pages/Legal";

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400">…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`} replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/member" replace />;
  if (role === "member" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<Forgot />} />
              <Route path="/reset-password" element={<Reset />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/member" element={<Guard role="member"><Member /></Guard>} />
              <Route path="/admin" element={<Guard role="admin"><Admin /></Guard>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/terms" element={<Legal kind="terms" />} />
              <Route path="/rules" element={<Legal kind="rules" />} />
              <Route path="/privacy" element={<Legal kind="privacy" />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </SiteProvider>
      </AuthProvider>
    </LangProvider>
  );
}
